/**
 * Variant BTS Gallery
 * v0.0.3-beta - May 20, 2025
 * 
 * Handles interaction for the variant-specific behind the scenes gallery.
 * - Integrates with Fancybox for lightbox functionality
 * - Handles variant changes to update the gallery
 * - Supports carousel and single image display modes
 */

class VariantBtsGallery {
    constructor() {
        this.galleries = document.querySelectorAll('[data-variant-bts-gallery]');
        this.variantSelectors = document.querySelectorAll('[data-variant-selector]');

        this.initEvents();
        this.initFancybox();
    }

    initEvents() {
        // Listen for variant change events
        document.addEventListener('variant:changed', this.handleVariantChange.bind(this));

        // Set up variant selector change listeners
        this.variantSelectors.forEach(selector => {
            selector.addEventListener('change', this.handleSelectorChange.bind(this));
        });

        // Focal-specific: variant change detection
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.name.includes('Focal')) {
            // Listen for Focal's variant change event
            document.addEventListener('variant:changed', function(event) {
                // With AJAX implementation, this is where you'd update the gallery
                // For now, the page will reload with Focal's built-in handling
            });
        }
    }

    initFancybox() {
        // Initialize Fancybox if available
        if (window.Fancybox || (window.$ && $.fancybox)) {
            const fancyboxOptions = {
                loop: true,
                buttons: [
                    "zoom",
                    "slideShow",
                    "fullScreen",
                    "close"
                ],
                animationEffect: "fade"
            };

            // Initialize with jQuery if that's how Fancybox is implemented
            if (window.$ && $.fancybox) {
                $('[data-fancybox^="variant-bts-gallery-"]').fancybox(fancyboxOptions);
            }
            // Otherwise use the modern Fancybox API
            else if (window.Fancybox) {
                Fancybox.bind('[data-fancybox^="variant-bts-gallery-"]', fancyboxOptions);
            }
        }

        // Focal-specific Fancybox initialization
        if (typeof Fancybox !== 'undefined') {
            Fancybox.bind('[data-fancybox="variant-gallery"]', {
                // Fancybox options
            });
        } else if (typeof $.fancybox !== 'undefined') {
            // Focal v8.10.5 might use an older jQuery-based Fancybox
            $('[data-fancybox="variant-gallery"]').fancybox({
                // Fancybox options
            });
        }
    }

    handleVariantChange(event) {
        const variant = event.detail.variant;
        if (!variant) return;

        // For a full implementation, we would fetch the variant's gallery data dynamically
        // and update the gallery without a page reload

        // For simplicity in this implementation, we're using a page reload strategy
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.location.href = url.toString();
    }

    handleSelectorChange(event) {
        // This would be used if we're not using a variant selector that emits variant:changed events
        // For themes that don't have built-in variant change events

        const variantId = event.currentTarget.value;
        if (!variantId) return;

        const url = new URL(window.location);
        url.searchParams.set('variant', variantId);
        window.location.href = url.toString();
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new VariantBtsGallery();
});